import { css } from 'lit';

export const posts = css`
  :host {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
    justify-content: center;
  }
  * {
    box-sizing: border-box;
  }

  .loading-list {
    color: #4b883c;
    font-weight: 400;
    font-family: 'Roboto', sans-serif;
  }
  .post-list {
    display: grid;
    width: 100%;
    gap: 3rem;
    margin: 0 auto;
  }

  .show-more_btn {
    text-decoration: none;
    color: #4b883c;
    cursor: pointer;
    font-family: var(--headings-font-family);
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 900;
    line-height: 120%;
    letter-spacing: -0.0225rem;
    display: inline-block;
    padding: 1.125rem 2rem;
    background-color: transparent;
    border-radius: 0.5rem;
    transition: 300ms ease-in-out;
    border: 2px solid #4b883c;
  }

  .show-more_btn:hover {
    color: #fafafa;
    background-color: #4b883c;
  }
  @media screen and (min-width: 768px) {
    .post-list {
      grid-template-columns: repeat(2, 1fr);
      gap: 1.5rem;
    }
  }

  @media screen and (min-width: 1024px) {
    .post-list {
      row-gap: 8rem;
    }
    single-post {
      width: 100%;
    }
  }
`;
